import React from "react";
import logo from "../images/logo_ecat.png";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  logo: {
    height: "auto",
    minWidth: "170px",
    maxWidth: "228px",
  },
}));

const Logo = ({ width, ...props }) => {
  const classes = useStyles();

  return (
    <img
      alt="Logo"
      src={logo}
      className={classes.logo}
      width={width}
      {...props}
    />
  );
};

export default Logo;
